import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=7c222b34&scoped=true"
import script from "./editAnnouncement.vue?vue&type=script&lang=js"
export * from "./editAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c222b34",
  null
  
)

export default component.exports